<template>
	<v-dialog
		:value="show"
		@input="hide(true)"
		max-width="fit-content"
		scrollable
		transition="dialog-transition">
			<v-card :class="status" class="event-dial-card">
				<v-card-title :class="status" class="headline py-2 px-3 darken-1">
					{{ title }}
					<v-spacer></v-spacer>
					<v-btn flat icon @click="hide(true)" class="my-0 mr-0 ml-5">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-title :class="status" class="darken-1 pt-1" v-if="loading">
					<v-progress-linear
						class="ma-0"
						height="2"
						color="white"
						:background-color="status"
						:indeterminate="true" />
				</v-card-title>
				<v-card-text
					class="py-2 px-3"
					v-if="message.length">
					<div class="subheading">
						<div
							v-for="(line, index) in message"
							:key="'message-' + index"
							v-safe-html.allowLinks="line">
						</div>
					</div>
				</v-card-text>
			</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'EventDial',
	data () {
		return {
			status: null,
			loading: false,
			title: null,
			message: [],
			timeout: null,
			timeout_var: null
		}
	},
	computed: {
		show () {
			return Boolean(this.status)
		}
	},
	methods: {
		// fromUser: true quand la fermeture vient d'une action explicite de
		// l'utilisateur (croix, clic en dehors, ESC) -> permet aux
		// composants appelants de détecter une annulation volontaire et
		// d'interrompre un traitement en cours (ex: analyse de dossier).
		// false pour les fermetures automatiques (timeout) qui ne doivent
		// surtout pas être interprétées comme une annulation.
		hide (fromUser) {
			if (this.timeout_var) {
				clearTimeout(this.timeout_var)
				this.timeout_var = null
			}
			this.loading = false
			this.title = null
			this.message = []
			this.timeout = null
			this.status = null
			if (fromUser) this.$Bus.$emit('event_dial_closed')
		}
	},
	watch: {
		timeout (val) {
			if (this.timeout_var) {
				clearTimeout(this.timeout_var)
				this.timeout_var = null
			}
			if (val > 0) {
				this.timeout_var = setTimeout(() => {
					this.hide(false)
				}, val)
			}
		}
	},
	mounted () {
		this.$Bus.$on('event_dial', (evt) => {
			if (evt.message) {
				if (!Array.isArray(evt.message)) evt.message = [evt.message]
			} else {
				evt.message = []
			}
			if (evt) {
				this.status = evt.status
				this.loading = evt.loading
				this.title = evt.title
				this.message = evt.message
				this.timeout = evt.timeout
			} else {
				this.hide(false)
			}
		})
	}
}
</script>

<style scoped>
.event-dial-card {
	min-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/App_event_dial.vue